/**
 *
 * @param {HTMLElement} element
 */
const ucasCalculator = function(element) {
  const domain = 'https://www.ucas.com/';

  let resultsElement;
  let gradesElement;
  let selectElement;

  let qualifications = []; // stores selected options
  let template;
  let qualList = []; // original array from UCAS stored for reference

  let qualOptions = '<option value="">Please select a qualification</option>';

  const renderTemplate = (qualOptions) => {
    const containerClasses = [
      'select-container',
      'my-5',
      'shadow',
      'd-block',
      'd-lg-flex',
      'justify-content-between',
    ];

    return `
    <div class="tariff-container">
      <h3>UCAS tariff points calculator</h3>
      <p>Select qualification dropdown list to reveal its grade and tariff
      point values</p>
      <form class="${ containerClasses.join(' ') }">
        <div class="select-control">
          <label for="ucas-qualification-select">Qualificiation</label>
          <select id="ucas-qualification-select">
            ${qualOptions}
          </select>
        </div>
        <a class="reset submit--reset mt-3 mt-lg-0">Reset</a>
      </form>
      <div id="grades" class="grades"></div>
      <div id="results" class="results"></div>
      <div class="disclaimer">
        <h4>Disclaimer</h4>
        <p>Remember the UCAS Tariff calculator is an indicative guide only.
        Not all universities and colleges use the Tariff. It is therefore
        really important that you check individual university and college
        requirements. Please ensure you read the key facts on the Tariff
        web page.</p>
      </div>
      <img src="https://www.ucas.com/sites/all/themes/ucas/logo.png"
        alt="" class="ucas-logo">
    </div>
    `;
  };

  /**
   * Utility function to convert an object to an array
   * @param {Object} obj
   * @return {Array}
   */
  const objToArray = (obj) => {
    return Object.keys(obj)
        .map((key) => [key, obj[key]]);
  };

  /**
   * Utility function to return data array from input URL
   *
   * @param {String} url
   * @return {Array}
   */
  const getData = async function(url) {
    const resultObject = await fetch(url)
        .then((response) => response.json())
        .then((data) => data);
    return objToArray(resultObject);
  };

  /**
   * This returns a list of qualifications from the UCAS website that we
   * can use to populate the drop down in the UCAS calculator
   *
   * @return {Promise}
   */
  const getQualOptions = async function() {
    const url = domain + 'api/tariff/v1/list';
    let quals = await getData(url);

    quals = quals.sort((a, b) => {
      const textA = a[1].toUpperCase().trim();
      const textB = b[1].toUpperCase().trim();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });

    return quals;
  };

  /**
   * Async function that return a list of potential grades for a selected
   * qualification
   *
   * @param {str} code - qualification code to find
   * @return {Promise}
   */
  const getGrades = async function(code) {
    const url = domain + 'api/tariff/v1/view/' + code;
    const grades = await getData(url);
    return grades;
  };

  /**
   * Async function that returns a list of list of select options
   *
   * @return {Promise}
   */
  const getSelectOptions = async function() {
    const quals = await getQualOptions();
    qualList = quals;

    const options = [];
    const renderOption = (value, text) => {
      return `<option value="${value}">${text}</option>`;
    };

    quals.forEach((item) => {
      options.push(renderOption(item[0], item[1]));
    });
    return options.join('');
  };

  /**
   *
   */
  const addChangeListener = function() {
    const gradesRender = (rows) => {
      return `
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">Grade</th>
          <th scope="col">Points</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        ${rows}
        </tbody>
      </table>
    `;
    };

    selectElement.addEventListener('change', function(e) {
      getGrades(selectElement.value).then((o) => {
        const items = [];
        o.forEach((item) => {
          const str = `
            <tr>
              <td>${item[0]}</td>
              <td>${item[1]}</td>
              <td>
                <button
                  class="add-grade"
                  data-code="${selectElement.value}"
                  data-grade="${item[0]}"
                  data-value="${item[1]}"
                  >Add</button>
              </td>
            </tr>
            `;
          items.push(str);
        });
        gradesElement.innerHTML = gradesRender(items.join(''));
      });
    });
  };

  /**
   * Click listener for adding a qualification to the calculator total
   */
  const addClickListener = () => {
    element.addEventListener('click', (e) => {
      let code;
      let i;
      let q;
      let o;

      if (e.target.hasAttribute('data-code')) {
        code = e.target.getAttribute('data-code');
        i = qualList.findIndex((item) => item[0] === code);
        q = qualList[i];

        o = {
          code: q[0],
          description: q[1],
          grade: e.target.getAttribute('data-grade'),
          value: e.target.getAttribute('data-value'),
        };

        qualifications.push(o);
        gradesElement.innerHTML = '';
        updateResults(qualifications);
        selectElement.selectedIndex = 0;
      }
    });
  };

  /**
   * This updates the results section once a grade is selected
   *
   * @param {Array} qualifications
   */
  const updateResults = (qualifications) => {
    const i = [];
    let total = 0;

    qualifications.forEach((o) => {
      const str = `
        <tr data-code="${o.code}">
          <td>${o.description}</td>
          <td>${o.grade}</td>
          <td>${o.value}</td>
        </td>
      `;
      i.push(str);
      const val = parseInt(o.value, 10);
      total += val;
    });

    let str = `
      <table class="table table-striped">
      <thead>
        <tr>
          <th>Qualification</th>
          <th>Grade</th>
          <th>Points</th>
        </tr>
      </thead>
      <tbody>
      `;

    str += i.join('');
    str += `
      </tbody>
      <tfoot>
        <tr>
          <td colspan="2">Total</td>
          <td>${total}</td>
        </tr>
      </tfoot>
      </table>
      `;

    resultsElement.innerHTML = str;
  };

  /**
   * Add a click listener to the reset button
   *
   * On click this should remove empty the list of qualifications and reset
   * the results section element to an empty string.
   */
  const addResetListener = () => {
    const resetTrigger = element.querySelector('.reset');

    resetTrigger.addEventListener('click', ( (e) => {
      e.preventDefault();
      qualifications = [];
      resultsElement.innerHTML = '';
      gradesElement.innerHTML = '';
      selectElement.selectedIndex = 0;
    }));
  };

  /**
   * Trigger the UCAS calculator
   */
  getSelectOptions().then((options) => {
    qualOptions += options;
    template = renderTemplate(qualOptions);
    element.innerHTML = template;

    // setup the elements for other functions to use
    selectElement = element.querySelector('#ucas-qualification-select');
    gradesElement = element.querySelector('#grades');
    resultsElement = element.querySelector('#results');

    addChangeListener();
    addClickListener();
    addResetListener();
  });
};

const ucasCalculatorInitialise = function(selector) {
  const els = document.querySelectorAll(selector);
  els.forEach((el) => {
    ucasCalculator(el);
  });
};

export default ucasCalculatorInitialise;

// ucasCalculatorInitialise('#tariff-calculator');
